<template>
    <v-navigation-drawer
        v-model="ventanaLateral"
        v-if="esMovil"
        clipped
        app
        width="320"
        color="#F9FAFD"
        overlay-color="#3A65AE"
        overlay-opacity="0.6"
    >
        <v-list>
            <router-link :to="{ name: 'inicio' }">
                <v-sheet class="py-3 mt-n3">
                    <v-img
                        src="./Logo.png"
                        max-height="80"
                        class="d-block d-md-none ma-4"
                    >
                    </v-img>
                </v-sheet>
            </router-link>
            <v-divider class="mb-6"></v-divider>
            <v-list-item
                v-for="(enlace, index) in enlacesMovil"
                :key="enlace.texto"
                :to="enlace.link"
                v-if="index != 3"
                :exact="index != 2"
                active-class="sin-brillo"
            >
                <v-list-item-icon>
                    <v-icon color="primary">{{ enlace.icono }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    {{ enlace.texto }}
                </v-list-item-content>
            </v-list-item>
            <ModalBusqueda>
                <v-list-item active-class="sin-brillo">
                    <v-list-item-icon>
                        <v-icon color="primary"> {{ enlacesMovil[3].icono }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        {{ enlacesMovil[3].texto }}
                    </v-list-item-content>
                </v-list-item>
            </ModalBusqueda>
            <v-divider class="my-3"></v-divider>
            <v-subheader>
                {{ $t("layout.menu-lateral.objetivos-estrategicos") }}
            </v-subheader>
            <v-list-item
                v-for="enlace in enlacesObjetivos"
                :key="enlace.texto"
                :to="enlace.link"
                three-line
                active-class="sin-brillo"
            >
                <v-list-item-icon>
                    <v-img :src="enlace.icono" max-width="50"></v-img>
                </v-list-item-icon>

                <v-list-item-content class="lista-objetivo-inicio">
                    {{ enlace.texto }}
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import ModalBusqueda from "../components/ModalBusqueda.vue";

export default {
    name: "MenuLateral",
    components: { ModalBusqueda },
    props: {
        drawer: {
            type: Boolean,
            required: true,
            default: false,
        },
        esMovil: {
            type: Boolean,
            required: true,
            default: false,
        },
        enlacesMovil: {
            type: Array,
            default: [],
        },
        enlacesObjetivos: {
            type: Array,
            default: [],
        },
    },
    watch: {
        drawer(newDrawer, oldDrawer) {
            this.ventanaLateral = newDrawer;
        },
        ventanaLateral(newDato, oldDato) {
            this.$emit("cambiarDrawner", newDato);
        },
    },
    data: () => ({
        ventanaLateral: false,
    }),
};
</script>
